import { render, staticRenderFns } from "./AvatarRow.vue?vue&type=template&id=5be110b7"
import script from "./AvatarRow.vue?vue&type=script&lang=ts"
export * from "./AvatarRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports